export const CUSTOM_FIELD_TYPE_MAPPER = {
  text: "Text",
  number: "Number",
  date: "Date",
  checkbox: "Checkbox",
  dropdown: "Dropdown",
};
